export default function Preformatted({ children }) {
    return <pre className={'preformatted'}>{children}</pre>
}
